import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
// core components
import { Table, Button } from "reactstrap";
import { upload } from "../../store/actions/vendor/Vendor";
import { connect } from "react-redux";
import { compose } from "redux";
import InputLabel from "@material-ui/core/InputLabel";
import {
  getProductDetails,
  getSuperCategory as getAllCategoryList,
  getAllSubCategory,
  getAllCategory as getCategoryList,
  updateProduct,
  updateVendorCommission,
} from "../../store/actions/vendor/Vendor";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import EditPassword from "./EditPassword";
import { MenuItem } from "@material-ui/core";

const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};
const useStyles = makeStyles(styles);

function EditSetting(props) {
  const classes = useStyles();

  const [commissionType, setCommissionType] = useState("Percentage");
  const [commissionValue, setCommissionValue] = useState(0);

  useEffect(() => {
    const { commissionType, commissionValue } = props;
    setCommissionType(commissionType);
    setCommissionValue(commissionValue);
  }, [props.commissionType, props.commissionValue]);

  const handleChange = (e) => {
    if (e.target) {
      if (e.target.name == "commissionType") setCommissionType(e.target.value);
      else if (e.target.name == "commissionValue")
        setCommissionValue(e.target.value);
    }
  };

  const onSave = () => {
    if (commissionType && !isNaN(commissionValue)) {
      props.updateVendorCommision({ commissionType, commissionValue });
    }
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Edit Settings</h4>
        <p className={classes.cardCategoryWhite}>
          Edit your commission, personal and business details.
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl
              className={classes.formControl}
              style={{ width: "100%" }}
            >
              <InputLabel style={{ color: "#AAAAAA" }}>
                Commission Type
              </InputLabel>
              <Select
                fullWidth
                value={commissionType}
                onChange={handleChange}
                inputProps={{
                  name: "commissionType",
                  id: "commissionType",
                }}
              >
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Fixed">Fixed</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl
              className={classes.formControl}
              style={{ width: "100%" }}
            >
              {/* <InputLabel style={{ color: "#AAAAAA" }}>Commission Value</InputLabel> */}
              <TextField
                required
                id="commissionValue"
                label="Commission Value"
                name="commissionValue"
                fullWidth
                type="number"
                InputProps={{
                  inputProps:
                    commissionType == "Percentage"
                      ? {
                          max: 100,
                          min: 0,
                        }
                      : { max: 1000000, min: 0 },
                }}
                value={commissionValue}
                onChange={(e) => {
                  let min = e.target.min;
                  let max = e.target.max;
                  var value = parseInt(e.target.value, 10);
                  if (value > max) value = max;
                  if (value < min) value = min;
                  handleChange({
                    target: { name: e.target.name, value },
                  });
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3} style={{ justifyContent: "center" }}>
            <Button
              onClick={onSave}
              variant="contained"
              color="primary"
              size="sm"
              style={{ marginTop: "10px" }}
            >
              Update Commission
            </Button>
          </GridItem>
        </GridContainer>
        <EditPassword />
      </CardBody>
      <CardFooter></CardFooter>
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
  }
  return {
    productDetails: state.vendor.productDetails,
    commissionType,
    commissionValue,
  };
};
const mapDispatchWithProps = (dispatch) => {
  return {
    updateVendorCommision: (data) => dispatch(updateVendorCommission(data)),
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(EditSetting);
